// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckboxFilterTag_root__ZjNIB","close":"CheckboxFilterTag_close__g4Wx2","closeIcon":"CheckboxFilterTag_closeIcon__7ixgg"};